module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "hiui-modal-fade"
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.isExist) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modal_show),
      expression: "modal_show"
    }],
    class: _vm.component_class,
    style: (_vm.component_style)
  }, [(_vm.use_mask) ? _c('div', {
    staticClass: "hiui-modal-mask",
    on: {
      "click": function($event) {
        _vm.closeModal('mask')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName[_vm.type]
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modal_show),
      expression: "modal_show"
    }],
    class: _vm.container_class
  }, [(_vm.use_close) ? _c('Icon', {
    class: _vm.icon_class,
    attrs: {
      "name": "close",
      "role": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.body_class,
    style: (_vm.body_style)
  }, [_vm._t("default")], 2)], 1)])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-833b2b62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/Modal.vue
// module id = 680
// module chunks = 0